import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MyImgRound from "../components/MyImgRound.js";
import { deletedCompanyRequest } from "../store/actions/companies.js";
import { word } from '../word.js'
import Cookies from 'js-cookie'
import { managerNotificationRequest, managerNotifyRequest } from "../store/actions/manager.js";
import Api from '../Api.js'
import SmartLink from "../components/SmartLink.js";

const Left = () => {
    const dispatch = useDispatch();
    const organization = useSelector((state) => state.companies.company);
    const notification = useSelector((state) => state.manager.notification);
    const note = useSelector((state) => state.manager.notify);
    const profession = Cookies.get("profession") || localStorage.getItem("profession") || "manager"
    const id = Cookies.get("id") || localStorage.getItem("id")
    const [dayoff, setDayoff] = useState(0)
    const [surveys, setSurveys] = useState(0)
    const login = useSelector((state) => state.manager.employee);
    const isAdmin = login?.user_id === 86 || login?.user_id === 1734 || login?.user_id === 2;
    const menuManager = [
        { id: 1, url: "/main_employee/staff", title: word.stuff },
        { id: 2, url: "/main_employee/organization", title: word.organizations },
        { id: 3, url: "/main_employee/users", title: word.users },
        { id: 4, url: "/main_employee/tasks", title: word.tasks },
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 14, url: "/main_employee/admin-agent", title: "Առաջադրանքների վճարում" },
        { id: 15, url: "/main_employee/wallet", title: "Դրամապանակ" },

        { id: 5, url: "/main_employee/archive", title: word.archive },
        { id: 6, url: "/main_employee/repeated_task", title: word.periodically_repetitive_tasks },
        { id: 7, url: "/main_employee/notification", title: word.notification },
        { id: 8, url: "/main_employee/reports", title: word.reports },
        { id: 9, url: "/main_employee/organization_file", title: word.accountant_file },
        { id: 10, url: "/main_employee/day_off", title: word.dayOff },
        { id: 11, url: "/main_employee/surveys", title: 'Հարցումներ' },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },

    ];

    const menuAccountant = [
        { id: 1, url: "/main_employee/tasks", title: word.tasks },
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 2, url: "/main_employee/repeated_task", title: word.periodically_repetitive_tasks },
        { id: 3, url: "/main_employee/archive", title: word.archive },
        { id: 4, url: "/main_employee/note", title: word.note },
        { id: 5, url: "/main_employee/notification", title: word.notification },
        { id: 6, url: "/main_employee/organization_file", title: word.accountant_file },
        { id: 7, url: "/main_employee/day_off", title: word.dayOff },
        { id: 11, url: "/main_employee/surveys", title: 'Հարցումներ' },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },
    ];
    const menuAgent = [
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 2, url: "/main_employee/wallet", title: "Դրամապանակ" },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },

    ];

    const menuList = profession === "manager" ? menuManager : profession === "agent" ? menuAgent : menuAccountant;
    
    // Filter out organizations (id: 2), users (id: 3), and organization_file for PEK theme
    const filteredMenuList = process.env.REACT_APP_SERVER === 'PEK' 
        ? menuList.filter(item => {
            // For manager: filter id 2, 3, and organization_file (id 9)
            // For accountant: filter organization_file (id 6)
            if (profession === "manager") {
                return item.id !== 2 && item.id !== 3 && !item.url.includes('/organization_file');
            } else if (profession === "accountant") {
                return !item.url.includes('/organization_file');
            }
            return true; // For agent, don't filter anything
        })
        : menuList;

    useEffect(() => {
        (async () => {
            await dispatch(deletedCompanyRequest())
            await dispatch(managerNotificationRequest());
            await dispatch(managerNotifyRequest());
            const day = await Api.dayOffCount();
            const survey = await Api.getSurveyCount();
            setSurveys(survey.data.draft_count)
            setDayoff(day.data.count)
        })()
    }, [profession, id]);

    return (
        <div className={"left"}>
            <div className="left-item left-item-hidden">
                <MyImgRound />
                <div className="left-item-name">
                    <span>Անուն Ազգանուն</span>
                    <div className="menu-line-active" />
                </div>
            </div>
            <div className="manager-left-menu">
                {filteredMenuList.map((item, index) => {
                    if (item.id !== 13 || login?.user?.canView || profession === "agent"){
                        if ((item.id === 14 || item.id === 15) && !isAdmin) {
                            return null;
                        }
                        return (
                            <SmartLink key={index} to={item.url} className={({ isActive }) => (isActive ? "active" : "")}>
                                <div className="left-item">
                                    <div className="new-notification">
                                        <span>{item.title}</span>
                                        {item.id === 2 && profession === "manager" && organization?.count ? (
                                            <div className="tasks-around">{organization?.count}</div>
                                        ) : null}
                                        {((item.id === 5 && profession === "accountant") || (item.id === 7 && profession === "manager")) && note ? (
                                            <div className="tasks-around">{note}</div>
                                        ) : null}
                                        {((item.id === 1 && profession === "accountant") || (item.id === 4 && profession === "manager")) && notification?.count ? (
                                            <div className="tasks-around">{notification?.count}</div>
                                        ) : null}

                                        {((item.id === 7 && profession === "accountant") || (item.id === 10 && profession === "manager")) && dayoff ? (
                                            <div className="tasks-around">{dayoff}</div>
                                        ) : null}
                                        {item.id === 11 && surveys ? (
                                            <div className="tasks-around">{surveys}</div>
                                        ) : null}
                                    </div>
                                    {window.location.href.includes(item.url) && <div className="menu-line" />}
                                </div>
                            </SmartLink>
                        )
                    }
                })}
            </div>
        </div>
    );
};

export default Left;
